/**
 * Countries where stripe's AddressElement provides built-in address autocomplete.
 * For countries not in this list, we use a custom google places autocomplete input
 * because stripe's `google_maps_api` mode loads its own google maps JS SDK which
 * conflicts with the one stripe loads for PaymentElement (causing URIError crashes).
 *
 * Source: https://docs.stripe.com/elements/address-element/collect-addresses#autocomplete
 * Last verified: 2026-04-11
 */
const STRIPE_AUTOCOMPLETE_COUNTRIES = new Set([
  'AU',
  'BE',
  'BR',
  'CA',
  'CH',
  'DE',
  'ES',
  'FR',
  'GB',
  'IE',
  'IN',
  'IT',
  'JP',
  'MX',
  'MY',
  'NL',
  'NO',
  'NZ',
  'PH',
  'PL',
  'RU',
  'SE',
  'SG',
  'TR',
  'US',
  'ZA',
]);

export function isStripeAutocompleteSupported(country: string): boolean {
  return STRIPE_AUTOCOMPLETE_COUNTRIES.has(country.toUpperCase());
}
